<div class="container-fluid">
    <div class="row pt-3">
        <div class="d-flex col-6 text-white mt-2 pointer" [routerLink]="['/report']">
            <div class="backicon">
                <i class="fa fa-arrow-left"></i>
            </div>

            <h3>Status</h3>
        </div>
        <div class="col-6 d-flex flex-row justify-content-end mb-2">
          
        </div>
    </div>
    <div class="row pt-2 text-white">
        <div class="col mx-4 border rounded Dashboard-tab view-request-col p-0">
            <div class="p-0 m-0 view-request-div">
                <div *ngIf="reportstatus && reportstatus.length > 0">
                <p-table [value]="reportstatus" [paginator]="true" [rows]="10">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Facility</th>

                            <th>DataPoints</th>
                            <th>Preparers</th>
                            <th>Approvers</th>
                            <th>Managers</th>
                            <th>Admins</th>
                            <th>Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-status>
                        <tr>
                            <td>{{ status.facilityName }}</td>

                            <td>{{ status.progress }}</td>
                            <td>{{ status.preparers }}</td>
                            <td>{{ status.approvers }}</td>
                            <td>{{ status.managers }}</td>
                            <td>
                                {{ status.admins }}
                            </td>

                            <td>
                                <div class="view-details">
                                    view Activities>>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div *ngIf="reportstatus && reportstatus.length === 0">
                <p class="nodata text-white">No data available</p>
            </div>
            </div>
          
           
        </div>
    </div>
</div>